import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginServiceService implements CanActivate {

  constructor(private route : ActivatedRoute) { }

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      let url = environment.awslogin;
      //this.router.navigateByUrl("/auth")
      localStorage.setItem('redirectURL',this.route.url[0].path)
      window.location.assign(url);
      resolve(true);
    })
  }

}
